import { useEffect, useState } from 'react';
import { BrandDealLimits, getBrandDealLimits } from '../api/payment/brand-deal.api';
import { DEFAULT_DEAL_LIMITS } from '../utils/brand-deal';

// Khoảng giá deal do admin cài. Hỏi một lần mỗi lần tải trang rồi dùng chung; lỗi mạng thì giữ mặc định,
// máy chủ vẫn kiểm lại nên không sai tiền.
let cached: Promise<BrandDealLimits> | null = null;

export const useBrandDealLimits = (): BrandDealLimits => {
  const [limits, setLimits] = useState<BrandDealLimits>(DEFAULT_DEAL_LIMITS);
  useEffect(() => {
    let alive = true;
    if (!cached) {
      cached = Promise.resolve()
        .then(() => getBrandDealLimits())
        .catch((e) => {
          cached = null;
          throw e;
        });
    }
    cached
      .then((v) => {
        if (alive && v?.minPriceVnd > 0) setLimits(v);
      })
      .catch(() => undefined);
    return () => {
      alive = false;
    };
  }, []);
  return limits;
};
